import { ComponentRoutes } from "../routing/component-routes";

export interface NavItem {
    title: string;
    route: string[];
    icon: string;
}

export const NavItems: NavItem[] = [
    {
        title: "Users",
        route: ["/", ComponentRoutes.users.root, ComponentRoutes.users.search],
        icon: "person",
    },
    {
        title: "Cheaters",
        route: ["/", ComponentRoutes.cheaters.root],
        icon: "report",
    },
    {
        title: "Games",
        route: ["/", ComponentRoutes.gameConfigs.root],
        icon: "sports_esports",
    },
    {
        title: "Virtual servers",
        route: ["/", ComponentRoutes.virtualServers.root],
        icon: "dns",
    },
    {
        title: "Game events",
        route: ["/", ComponentRoutes.gameEvents.root],
        icon: "event",
    },
    {
        title: "Inbox",
        route: ["/", ComponentRoutes.inbox.root],
        icon: "inbox",
    },
    {
        title: "Server's Load",
        route: ["/", ComponentRoutes.serverLoad.root],
        icon: "monitor_heart",
    },
    {
        title: "AI moderation",
        route: ["/", ComponentRoutes.aiModeration.root],
        icon: "gavel",
    },
    {
        title: "Whitelist",
        route: ["/", ComponentRoutes.backofficeUsers.root],
        icon: "admin_panel_settings",
    },
];
